import { CONDITIONS } from "../types/conditionsTypes";

export interface IConditions {
  // payrollApiCallsAfterUpdateGeneralSettings: boolean;
}

const initialState: IConditions = {
  // payrollApiCallsAfterUpdateGeneralSettings: false,
};

export const conditionsReducer = (
  state: IConditions = initialState,
  action: any,
): IConditions => {
  switch (action.type) {
    case CONDITIONS.CONDITIONS_SET_SELECTED:
      return {
        ...state,
        // payrollApiCallsAfterUpdateGeneralSettings:
        //   action.payload.payrollApiCallsAfterUpdateGeneralSettings,
      };
    case CONDITIONS.CONDITIONS_CLEAR_SELECTED:
      return {
        ...state,
        // payrollApiCallsAfterUpdateGeneralSettings:
        //   initialState.payrollApiCallsAfterUpdateGeneralSettings,
      };
    default:
      return state;
  }
};
